import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../AppContext";

const UpgradeModal = ({ 
  isOpen, 
  featureType, 
  currentLimit, 
  currentCount
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { closeModal } = useAppContext();

  if (!isOpen) return null;

  const getFeatureMessage = () => {
    const messages = {
      'Organizations': t('You have reached your organization limit'),
      'Projects': t('You have reached your domain limit'),
      'Users': t('You have reached your user limit'),
      'AI': t('You have reached your AI calls limit for this week'),
      'Export': t('Export functionality is not available on trial accounts')
    };
    return messages[featureType] || t('You have reached your limit');
  };

  const handleUpgrade = () => {
    navigate('/payment');
    closeModal();
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={closeModal}
    >
      <div 
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '25px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto 15px',
            backgroundColor: '#fff3cd',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="icon-Risico" style={{ fontSize: '28px', color: 'var(--yellow-risk-score)' }} />
          </div>
          <h2 style={{ margin: '0 0 10px 0', fontSize: '24px', fontWeight: '600' }}>
            {t('Upgrade Required')}
          </h2>
          <p style={{ margin: 0, color: '#666', fontSize: '15px' }}>
            {getFeatureMessage()}
          </p>
        </div>

        {/* Current Usage - Only show for non-export features */}
        {featureType !== 'Export' && (
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            padding: '15px',
            marginBottom: '20px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: '500' }}>{t('Current Usage')}:</span>
              <span style={{ 
                fontWeight: '600', 
                color: 'var(--red-risk-score)',
                fontSize: '18px'
              }}>
                {currentCount} / {currentLimit === -1 ? '∞' : currentLimit}
              </span>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
          <button
            onClick={handleUpgrade}
            style={{
              flex: 1,
              padding: '12px 20px',
              backgroundColor: 'var(--text-color)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--text-color)'}
          >
            <i className="icon-arrow-up" style={{ marginRight: '8px' }} />
            {t('Upgrade Now')}
          </button>
          
          <button
            onClick={closeModal}
            style={{
              flex: 1,
              padding: '12px 20px',
              backgroundColor: 'white',
              color: 'var(--text-color)',
              border: '2px solid var(--text-color)',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--text-color)';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'var(--text-color)';
            }}
          >
            {t('Maybe Later')}
          </button>
        </div>

        {/* Help Text */}
        <div style={{ 
          marginTop: '20px', 
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          fontSize: '13px',
          color: '#666',
          textAlign: 'center'
        }}>
          <i className="icon-info" style={{ marginRight: '5px' }} />
          {t('Questions? Contact us at')}{' '}
          <a href="mailto:info@risqui.nl" style={{ color: 'var(--text-color)', textDecoration: 'none' }}>
            info@risqui.nl
          </a>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
